import LinksIegm from "@/views/questionarios/LinksIegm.vue";

const questionariosRotas = [
  {
    path: "/links-iegm",
    name: "questionarios--links-iegm",
    component: LinksIegm,
  },
];

export { questionariosRotas };
